export const apiConfig: any = {
    masters: {
        features: [
            {
                name: 'currencies',
                method: 'GET',
                path: '/currencies/'
            },
            {
                name: 'exchangerates',
                method: 'GET',
                path: '/currencies/{}/exchange'
            },
            {
                name: 'preferences',
                method: 'GET',
                path: '/preferences'
            },
            {
                name: 'calculateGst',
                method: 'POST',
                path: '/gst/calculate'
            },
            {
                name: 'fetchEnumsByCompany',
                method: 'GET',
                path: '/masters/company/{}/{}'
            },
            {
                name: 'gststatecodes',
                method: 'GET',
                path: '/gst/statecodes'
            },
        ]
    },
    airport: {
        features: [
            {
                name: 'fetchAllAirports',
                method: 'GET',
                path: '/airports'
            },
            {
                name: 'fetchNearbyAirports',
                method: 'GET',
                path: '/airports/{}/nearby'
            }
        ]
    },
   
    airInfo: {
        features: [
            {
                name: 'saveSeatMap',
                method: 'PUT',
                path: '/seatmaps/{}'
            },   {
                name: 'schedule',
                method: 'GET',
                path: '/schedules'
            },
            {
                name: 'stops',
                method: 'GET',
                path: '/flightStops'
            },
            {
                name: 'flightinfos',
                method: 'GET',
                path: '/flightinfos/{}'
            },
            {
                name: 'flightlegs',
                method: 'GET',
                path: '/flightlegs'
            }
        ]
    },
    airline: {
        features: [
            {
                name: 'airline',
                method: 'GET',
                path: '/airlines'
            }
        ]
    },
    airinfo: {
        features: [
            {
                name: 'saveSeatMap',
                method: 'PUT',
                path: '/seatmaps/{}'
            },
            {
                name: 'schedule',
                method: 'GET',
                path: '/schedules'
            },
            {
                name: 'stops',
                method: 'GET',
                path: '/flightStops'
            },
            {
                name: 'flightinfos',
                method: 'GET',
                path: '/flightinfos/{}'
            },
            {
                name: 'flightlegs',
                method: 'GET',
                path: '/flightlegs'
            },
            {
                name: 'seatmap',
                method: 'POST',
                path: '/seatmaps/{}'
            }
        ]
    },
    auth: {
        features: [
            {
                name: 'login',
                method: 'POST',
                path: '/token'
            },
            {
                name: 'requestOtp',
                method: 'POST',
                path: '/otp/requests'
            },
            {
                name: 'validateOtp',
                method: 'POST',
                path: '/otp/requests'
            },
            {
                name: 'changePassword',
                method: 'POST',
                path: '/resetpassword/requests'
            },
            {
                name: 'refreshToken',
                method: 'POST',
                path: '/token'
            },
            {
                name: 'searchAccounts',
                method: 'GET',
                path: '/accounts'
            },
            {
                name: 'saveAccount',
                method: 'POST',
                path: '/accounts'
            },
            {
                name: 'updateAccount',
                method: 'POST',
                path: '/accounts/{}'
            },
            {
                name: 'fetchAccountDetails',
                method: 'GET',
                path: '/accounts'
            },
            {
                name: 'markAsActivated',
                method: 'POST',
                path: '/accounts/{}/status/activated'
            },
            {
                name: 'markAsDisabled',
                method: 'POST',
                path: '/accounts/{}/status/disabled'
            },
            {
                name: 'changeAccountStatus',
                method: 'POST',
                path: '/accounts/{}/status/{}'
            },
            {
                name: 'apikeys',
                method: 'POST',
                path: '/apikeys'
            },
            {

                name: 'createApiKey',
                method: 'POST',
                path: '/apikeys/requests'
            },
            {

                name: 'deleteApiKey',
                method: 'POST',
                path: '/apikeys/{}'
            }
        ]
    },
    policy: {
        features: [
            {
                name: 'fetchPolicy',
                method: 'GET',
                path: '/policies/company/{}/'
            }
        ]
    },
    companymaster: {
        features: [
            {
                name: 'fetchEnums',
                method: 'GET',
                path: '/masters/{}'
            },
            {
                name: 'configparams',
                method: 'GET',
                path: '/platform/parameters/{}'
            },
        ]
    },
    bookings: {
        features: [
            {
                name: 'fetchBookingEntries',
                method: 'GET',
                path: '/orders/bookingentries'
            },
            {
                name: 'createAdhocOrderItem',
                method: 'POST',
                path: '/orders/adhoc/'
            },
            {
                name: 'updateAdhocOrderItem',
                method: 'POST',
                path: '/orders/adhoc/{}'
            },
            {
                name: 'cancelAdhocOrderItem',
                method: 'POST',
                path: '/orders/adhoc/{}/actions'
            },
            {
                name: 'voidAdhocOrderItem',
                method: 'POST',
                path: '/orders/adhoc/{}/actions/void'
            },
            {
                name: 'voidAdhocOrderItemTransaction',
                method: 'POST',
                path: '/orders/adhoc/{}/txnamounts/{}/actions/void'
            },            
            {
                name: 'fetchAdhocOrderItem',
                method: 'GET',
                path: '/orders/adhoc/{}'
            },
            {
                name: 'editAdhocOrderItem',
                method: 'PUT',
                path: '/orders/adhoc/{}/txnamounts/{}'
            },
            {
                name: 'fetchFlightQuotesForRequest',
                method: 'GET',
                path: '/quotes/flights/'
            },
            {
                name: 'fetchHotelQuotesForRequest',
                method: 'GET',
                path: '/quotes/hotels/'
            },
            {
                name: 'fetchCabQuotesForRequest',
                method: 'GET',
                path: '/quotes/cabs'
            },
            {
                name: 'saveOrders',
                method: 'POST',
                path: '/orders/batch/adhoc'
            },
            {
                name: 'updateOrderItemStatus',
                method: 'POST',
                path: '/orders/orderitems/{}/txnamounts'
            },
            {
                name: 'fetchCheckinRequests',
                method: 'POST',
                path: '/checkinrequests/flights'
            },
            {
                name: 'saveCheckinRequest',
                method: 'POST',
                path: '/checkinrequests/flights'
            },
            {
                name: 'syncFlightCheckinRequest',
                method: 'POST',
                path: '/checkinrequests/flights/{}/flightlegs'
            },
            {
                name: 'updateFulfillment',
                method: 'POST',
                path: '/checkinrequests/flights/{}/fulfill'
            },
            {
                name: 'cancelBusBooking',
                method: 'POST',
                path: '/orders/buses/{}/actions'
            },
            {
                name: 'updateBusBooking',
                method: 'POST',
                path: '/orders/buses/{}'
            },
            {
                name: 'saveBusBooking',
                method: 'POST',
                path: '/orders/buses/'
            },
            {
                name: 'fetchBookingDocuments',
                method: 'GET',
                path: '/orders/orderitems/documents'
            },
            {
                name: 'fetchBusBooking',
                method: 'GET',
                path: '/orders/buses/{}'
            },
            {
                name: 'searchBusBookings',
                method: 'GET',
                path: '/orders/buses/'
            },
            {
                name: 'cancelRailBooking',
                method: 'POST',
                path: '/orders/rail/{}/actions'
            },
            {
                name: 'updateRailBooking',
                method: 'POST',
                path: '/orders/rail/{}'
            },
            {
                name: 'saveRailBooking',
                method: 'POST',
                path: '/orders/rail/'
            },
            {
                name: 'fetchRailBooking',
                method: 'GET',
                path: '/orders/rail/{}'
            },
            {
                name: 'searchRailBookings',
                method: 'GET',
                path: '/orders/rail/'
            },
            {
                name: 'fetchFlightBooking',
                method: 'GET',
                path: '/orders/flights/{}'
            },
            {
                name: 'fetchCabBooking',
                method: 'GET',
                path: '/orders/cabs/{}'
            },            
            {
                name: 'updateCabBooking',
                method: 'PUT',
                path: '/orders/cabs/{}/'
            },  
            {
                name: 'fetchBookingDocuments',
                method: 'GET',
                path: '/orders/orderitems/documents'
            },
            {
                name: 'fetchFlightOrderItems',
                method: 'GET',
                path: '/orders/flights'
            },
            {
                name: 'fetchHotelOrderItems',
                method: 'GET',
                path: '/orders/hotels'
            }                         
        ]
    },
    user: {
        features: [
            {
                name: 'fetchUserDetails',
                method: 'GET',
                path: '/users'
            },
            {
                name: 'fetchUsersForCompany',
                method: 'GET',
                path: '/users'
            },
            {
                name: 'fetchGuestDetails',
                method: 'GET',
                path: '/guests/'
            },
            {
                name: 'fetchCompanyGuestDetails',
                method: 'GET',
                path: '/guests/company/{}'
            },
            {
                name: 'saveGuest',
                method: 'POST',
                path: '/guests/'
            },
            {
                name: 'saveUser',
                method: 'POST',
                path: '/users'
            },
            {
                name: 'updateUser',
                method: 'PUT',
                path: '/users'
            },
            {
                name: 'updateUserStatus',
                method: 'PUT',
                path: '/users/{}/status'
            },
        ]
    },
    vendor: {
        features: [
            {
                name: 'searchVendors',
                method: 'GET',
                path: '/vendors'
            },
            {
                name: 'searchVendorById',
                method: 'GET',
                path: '/vendors/{}'
            },
            {
                name: 'searchVendorContracts',
                method: 'GET',
                path: '/vendors/contracts'
            },
            {
                name: 'updateVendorContact',
                method: 'POST',
                path: '/vendors/{}/contracts/{}/contacts'
            },
            {
                name: 'deleteVendorContact',
                method: 'DELETE',
                path: '/vendors/{}/contracts/{}/contacts/{}'
            },
            {
                name: 'activateVendorContact',
                method: 'POST',
                path: '/vendors/{}/contracts/{}/contacts/{}/activated'
            },
            {
                name: 'fetchPartnershipContracts',
                method: 'GET',
                path: '/vendors/{}/contracts'
            },
            {
                name: 'addPartnershipContracts',
                method: 'POST',
                path: '/vendors/{}/contracts'
            },
            {
                name: 'fetchPartnershipContractsForCompany',
                method: 'POST',
                path: '/vendors/{}/contracts/partneships/{}'
            },
            {
                name: 'fetchSuppliersOfVendor',
                method: 'GET',
                path: '/vendors/{}/suppliers'
            },
            {
                name: 'saveSupplierDetails',
                method: 'PUT',
                path: '/vendors/{}/suppliers'
            },
            {
                name: 'saveCabRate',
                method: 'PUT',
                path: '/vendors/{}/cabrates/{}'
            },
            {
                name: 'fetchCabRates',
                method: 'PUT',
                path: '/vendors/cabrates'
            },
            {
                name: 'fetchCabRateById',
                method: 'GET',
                path: '/vendors/cabrates/{}'
            },
            {
                name: 'fetchVendorUsers',
                method: 'GET',
                path: '/vendors/{}/users'
            },

        ]
    },
    company: {
        features: [
            {
                name: 'fetchCompanyDetail',
                method: 'GET',
                path: '/companies/{}'
            },
            {
                name: 'listOnboardingRequests',
                method: 'GET',
                path: '/onboarding/requests'
            },
            {
                name: 'createOnboardingRequest',
                method: 'POST',
                path: '/onboarding/requests/'
            },
            {
                name: 'amendOnboardingRequest',
                method: 'PUT',
                path: '/onboarding/requests/{}'
            },
            {
                name: 'deleteOnboardingRequest',
                method: 'DELETE',
                path: '/onboarding/requests/{}'
            },
            {
                name: 'activateOnboardingRequest',
                method: 'POST',
                path: '/onboarding/requests/{}/activate'
            },
            {
                name: 'activateAdmin',
                method: 'POST',
                path: '/onboarding/requests/{}/admin/{}/activate'
            },
            {
                name: 'assignOnboardingRequests',
                method: 'GET',
                path: '/vendors/{}/users'
            },
            {
                name: 'assignUser',
                mathod: 'POST',
                path: '/onboarding/requests/{}/assignee'
            },
            {
                name: 'fetchAllCompanies',
                method: 'GET',
                path: '/companies'
            },
            {
                name: 'fetchCompanyById',
                method: 'GET',
                path: '/companies/{}'
            },
            {
                name: 'fetchDepartments',
                method: 'GET',
                path: '/companies/{}/departments'
            },
            {
                name: 'fetchEmployeesByFilter',
                method: 'GET',
                path: '/company/{}/employees'
            },
            {
                name: 'fetchCompanyParameters',
                method: 'GET',
                path: '/companies/{}/parameters'
            },
            {
                name: 'addCompanyParameters',
                method: 'POST',
                path: '/companies/{}/parameters'
            },
            {
                name: 'saveOffice',
                method: 'POST',
                path: '/companies/{}/offices'
            },
            {
                name: 'saveCompany',
                method: 'PUT',
                path: '/companies/{}'
            },
            {
                name: 'saveEmployee',
                method: 'POST',
                path: '/company/{}/employees'
            },
        ]
    },
    refresh: {
        features: [
            {
                name: 'refreshFlightSchedule',
                method: 'POST',
                path: '/flightinfos/_refresh'
            }
        ]
    },
    alert: {
        features: [
            {
                name: 'createFlightAlerts',
                method: 'POST',
                path: '/manualflightalerts/{}'
            },
            {
                name: 'fetchFlightAlerts',
                method: 'GET',
                path: '/manualflightalerts'
            },
            {
                name: 'deleteFlightAlert',
                method: 'DELETE',
                path: '/manualflightalerts/{}'
            }
        ]
    },
    journeys: {
        features: [
            {
                name: 'broadcast',
                method: 'POST',
                path: '/broadcast/'
            },
            {
                name: 'broadcastTemplate',
                method: 'POST',
                path: '/messagetemplates?feature=trm'
            }
        ]
    },
    reports: {
        features: [
            {
                name: 'performMisSummary',
                method: 'POST',
                path: '/query/report/'
            },
            {
                name: 'performReportQuery',
                method: 'POST',
                path: '/query/report/'
            },
            {
                name: 'exportToExcel',
                method: 'POST',
                path: '/enquiry/report/xls'
            },
            {
                name: 'amendFlightSchedule',
                method: 'POST',
                path: '/flightinfos/{flightKey}/terminal'
            },
            {
                name: 'fetchReportDefinitions',
                method: 'GET',
                path: '/reports/'
            },
            {
                name: 'exportToExcel',
                method: 'POST',
                path: '/enquiry/report/xls'
            }            
        ]
    },
    invoice: {
        features: [
            {
                name: 'createInvoice',
                method: 'GET',
                path: '/invoice'
            },
            {
                name: 'fetchInvoices',
                method: 'GET',
                path: '/invoice'
            },
            {
                name: 'fetchInvoiceById',
                method: 'GET',
                path: '/invoice/{}'
            },
            {
                name: 'fetchInvoiceComments',
                method: 'GET',
                path: '/invoice/{}/comments'
            },
            {
                name: 'createInvoiceComment',
                method: 'POST',
                path: '/invoice/{}/comments'
            },
            {
                name: 'updateInvoiceStatus',
                method: 'POST',
                path: '/invoice/{}/status/{}'
            },
            {
                name: 'updateInvoiceDocument',
                method: 'POST',
                path: '/invoice/{}/documents'
            },
            {
                name: 'fetchInvoiceStatusHistory',
                method: 'GET',
                path: '/invoice/{}/status/history'
            },
            {
                name: 'fetchInvoicePermissibleStates',
                method: 'GET',
                path: '/invoice/{}/status/next'
            },
            {
                name: 'fetchInvoiceComments',
                method: 'GET',
                path: '/invoice/{}/comments'
            },
            {
                name: 'previewInvoice',
                method: 'GET',
                path: '/invoice/actions/preview'
            },
            {
                name: 'generateInvoice',
                method: 'POST',
                path: '/invoice/actions/generate'
            },
            {
                name: 'downloadInvoice',
                method: 'POST',
                path: '/invoice/actions/download'
            },
            {
                name: 'createSupplierInvoice',
                method: 'POST',
                path: '/supplierinvoices'
            },
            {
                name: 'fetchSupplierInvoices',
                method: 'GET',
                path: '/supplierinvoices'
            },
            {
                name: 'fetchSupplierInvoiceById',
                method: 'GET',
                path: '/supplierinvoices/{}'
            },
            {
                name: 'updateSupplierInvoice',
                method: 'PUT',
                path: '/supplierinvoices/{}'
            },
            {
                name: 'splitInvoice',
                method: 'POST',
                path: '/invoice/actions/split'
            },
            {
                name: 'reviseInvoice',
                method: 'POST',
                path: '/invoice/actions/revise'
            },
            {
                name: 'reissueInvoice',
                method: 'POST',
                path: '/invoice/actions/reissue'
            },
            {
                name: 'fetchAirlineGstInvoices',
                method: 'GET',
                path: '/gstinvoices/air'
            },
            {
                name: 'downloadInvoices',
                method: 'POST',
                path: '/invoice/actions/download/bulk'
            },    
            {
                name: 'fetchLastInvoice',
                method: 'GET',
                path: '/invoice/last'
            },   
            {
                name: 'fetchAirGstInvoiceResponseGroup',
                method: 'GET',
                path: '/gstinvoices/air/responsegroup/{}'
            },
            {
                name: 'saveAirlineGstInvoice',
                method: 'POST',
                path: '/gstinvoices/air'
            }      
                                     
        ]
    },
    document: {
        features: [
            {
                name: 'uploadDocument',
                method: 'POST',
                path: '/documents'
            },
            {
                name: 'fetchDocuments',
                method: 'GET',
                path: '/documents'
            },
            {
                name: 'fetchDocumentDetail',
                method: 'GET',
                path: '/documents/{}/content'
            },
            {
                name: 'deleteDocument',
                method: 'DELETE',
                path: '/documents/{}'
            }
        ]
    },
    ledger: {
        features: [
            {
                name: 'saveLedgerEntries',
                method: 'POST',
                path: '/ledger/entries'
            },
            {
                name: 'updateLedgerEntry',
                method: 'PUT',
                path: '/ledger/entries/{}'
            },            
            {
                name: 'fetchLedgerEntryList',
                method: 'GET',
                path: '/ledger/entries'
            },
            {
                name: 'fetchLedgerEntry',
                method: 'GET',
                path: '/ledger/entries/{}'
            },
            {
                name: 'attachSupplierInvoice',
                method: 'POST',
                path: '/ledger/entries/bulkactions/supplierinvoices/attach'
            },
            {
                name: 'updateLedgerEntryStatus',
                method: 'POST',
                path: '/ledger/entries/bulkactions/status/update'
            }            
        ]
    },
    quote: {
        features: [
            {
                name: 'listQuoteRequests',
                method: 'GET',
                path: '/quoterequests'
            },
            {
                name: 'fetchBusQuotesForRequest',
                method: 'GET',
                path: '/quotes/bus/'
            },
            {
                name: 'fetchBusQuote',
                method: 'GET',
                path: '/quotes/bus/{}'
            },
            {
                name: 'fetchQuoteRequestById',
                method: 'GET',
                path: '/quoterequests/{}'
            },
            {
                name: 'saveBusQuote',
                method: 'POST',
                path: '/quotes/bus/'
            },
            {
                name: 'amendBusQuote',
                method: 'POST',
                path: '/quotes/bus/{}'
            },
            {
                name: 'actionBusQuote',
                method: 'POST',
                path: '/quotes/bus/{}/actions'
            },
            {
                name: 'actionRailQuote',
                method: 'POST',
                path: '/quotes/rail/{}/actions'
            },
            {
                name: 'fetchCommentsForQuote',
                method: 'GET',
                path: '/quotes/comments/'
            },
            {
                name: 'addCommentForQuote',
                method: 'POST',
                path: '/quotes/comments/'
            },
            {
                name: 'markAsQuoteComplete',
                method: 'GET',
                path: '/quoterequests/{}/vendors/{}/{}/action/{}'
            },
            {
                name: 'fetchQuoteSummaries',
                method: 'GET',
                path: '/quotes/summaries/'
            },
            {
                name: 'fetchQuoteRequestItemsCount',
                method: 'GET',
                path: '/quoterequests/count/{}'
            },
            {
                name: 'fetchQuoteRequests',
                method: 'GET',
                path: '/quoterequests/{}/{}'
            },
            {
                name: 'saveRailQuotes',
                method: 'PUT',
                path: '/quotes/rail/'
            }, 
            {
                name: 'fetchRailQuotesForRequest',
                method: 'GET',
                path: '/quotes/rail/'
            },
            {
                name: 'finalizeQuotes',
                method: 'GET',
                path: '/quoterequests/{}/vendors/{}/{}/action/{}'
            },
            {
                name: 'fetchRailQuote',
                method: 'GET',
                path: '/quotes/rail/{}'
            },
            {
                name: 'updateQuoteRequestWithDefaultFulfillmentMode',
                method: 'POST',
                path: '/quoterequests/actions/fulfillmentmode/default'
            }            
        ],

    },
    bus: {
        features: [
            {
                name: 'fetchBusStations',
                method: 'GET',
                path: '/bus/masters/stations'
            }
        ]
    },
    shopping: {
        features: [
            {
                name: 'cancelBusOrder',
                method: 'POST',
                path: '/shopping/buses/orders/cancel'
            }
        ]
    },

    quickCart: {
        features: [
            {
                name: 'publishQuickcart',
                method: 'POST',
                path: '/quickcart/{}/actions/publish'
            },
            {
                name: 'fetchQuickCart',
                method: 'GET',
                path: '/quickcart/{}'
            },
        ]
    },

    flights: {
        features: [
            {
                name: 'search',
                method: 'POST',
                path: '/flightoffers/search'
            },
            {
                name: 'fetchQuickCart',
                method: 'GET',
                path: '/quickcart/{}'
            },
            {
                name: 'saveQuickcart',
                method: 'POST',
                path: '/quickcart/'
            },
            {
                name: 'loadFlightCartWithAncillaries',
                method: 'POST',
                path: '/quickcart/{}/flights/{}/ancillaries'
            },
            {
                name: 'seatAvailability',
                method: 'POST',
                path: '/flightoffers/{}/sector/{}/seats'
            },
            {
                name: 'refreshFlightCart',
                method: 'POST',
                path: '/shoppingcart/flights/{}/refresh'
            },
            {
                name: 'fetchQuoteRequestDetail',
                method: 'GET',
                path: '/quoterequests/{}'
            },
            {
                name: 'revalidateQuickCart',
                method: 'POST',
                path: '/quickcart/{}/actions/revalidate'
            },
            {
                name: 'fetchQuoteRequestDetail',
                method: 'GET',
                path: '/quoterequests/{}'
            },
            {
                name: 'revalidate',
                method: 'POST',
                path: '/flightoffers/{}/revalidate'
            },   
            {
                name: 'share',
                method: 'POST',
                path: '/flightoffers/share'
            },
            {
                name: 'checkoutcart',
                method: 'GET',
                path: '/shoppingcart/flights/{}/checkout'
            },         
        ]
    },
    hotels:{
        features: [
            {
                name: 'shopping-search',
                method: 'POST',
                path: '/shopping/hotels/search'
            },
            {
                name: 'shopping-hotel-detail',
                method: 'POST',
                path: '/shopping/hotels/{}/rooms'
            },
            {
                name: 'fetchCancellationPolicy',
                method: 'POST',
                path: '/hotels/cxlpolicy'
            },
            {
                name: 'listHotels',
                method: 'GET',
                path: '/hotels/hotelinfo'
            },
            {
                name: 'hoteldetail',
                method: 'GET',
                path: '/hotels/hoteldetail'
            },
            {
                name: 'destinationCountries',
                method: 'GET',
                path: '/hotels/destinations/countries'
            },
            {
                name: 'saveHotel',
                method: 'POST',
                path: '/hotels/hotelstaticdata'
            },
            {
                name: 'editHotel',
                method: 'PUT',
                path: '/hotels/{}'
            },
            {
                name: 'destinationCities',
                method: 'GET',
                path: '/hotels/destinations/cities'
            },
            {
                name: 'deleteHotel',
                method: 'DELETE',
                path: '/hotels/hotelstaticdata'
            },
            {
                name: 'location',
                method: 'GET',
                path: '/hotels/location'
            },
            {
                name: 'hotelProviders',
                method: 'GET',
                path: '/hotels/providers'
            },
            {
                name: 'share',
                method: 'POST',
                path: '/shopping/hotels/share'
            },
            {
                name: 'createcart',
                method: 'POST',
                path: '/shoppingcart/hotels'
            },
            {
                name: 'fetchcart',
                method: 'GET',
                path: '/shoppingcart/hotels/{}'
            },
            {
                name: 'updatecart',
                method: 'PUT',
                path: '/shoppingcart/hotels/{}'
            },
            {
                name: 'checkoutcart',
                method: 'GET',
                path: '/shoppingcart/hotels/{}/checkout'
            },
            { 
                name: 'refreshHotelCart',
                method: 'POST',
                path: '/shoppingcart/hotels/{}/refresh'
            },
        ]
    },
    visa: {
        features: [
            {
                name: 'fetchVisaRequests',
                method: 'GET',
                path: '/visas/requests'
            },
            {
                name: 'fetchVisaRequest',
                method: 'GET',
                path: '/visas/requests/{}'
            },
            {
                name: 'createChatMessage',
                method: 'POST',
                path: '/visas/requests/{}/chatmessages/'
            },
            {
                name: 'fetchChatMessages',
                method: 'GET',
                path: '/visas/requests/{}/chatmessages/'
            },
            {
                name: 'markChatMessageAsRead',
                method: 'PUT',
                path: '/visas/requests/{}/chatmessages/{}/actions/read'
            },
            {
                name: 'flagChatMessage',
                method: 'PUT',
                path: '/visas/requests/{}/chatmessages/{}/actions/flag'
            },
            {
                name: 'clearChatMessageFlag',
                method: 'PUT',
                path: '/visas/requests/{}/chatmessages/{}/actions/clearflag'
            },
            {
                name: 'updateVisaStatus',
                method: 'POST',
                path: '/visas/requests/updatestatus/{}'
            },
            {
                name: 'updateVisaStage',
                method: 'POST',
                path: '/visas/requests/updateStage/{}'
            },
        ]
    },
    rail: {
        features: [
            {
                name: 'fetchRailStations',
                method: 'GET',
                path: '/rail/masters/stations'
            },
            {
                name: 'fetchRailEnums',
                method: 'GET',
                path: '/masters/{}'
            },
            {
                name: 'fetchRailSchedules',
                method: 'GET',
                path: '/rail/masters/schedule'
            },
            {
                name: 'fetchRailSchedule',
                method: 'GET',
                path: '/rail/masters/schedule/{}'
            }             
        ]
    },
    priceAlerts: {
        features: [
            {
                name: 'search',
                method: 'GET',
                path: '/price-alerts/'
            },
            {
                name: 'createPriceAlert',
                method: 'POST',
                path: '/price-alerts/'
            },
            {
                name: 'updatePriceAlertRequestStatus',
                method: 'PUT',
                path: '/price-alerts/{}/status'
            },
 
        ]
    },
};